import type { RouteObject } from "react-router-dom"
import Home from "@/pages/Home"
import AdminLogin from "@/pages/AdminLogin"
import AdminOrders from "@/pages/AdminOrders"
import { useRoutes } from "react-router-dom"

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/admin", element: <AdminLogin /> },
  { path: "/admin/orders", element: <AdminOrders /> },
]

function App() {
  return useRoutes(routes)
}

export default App
